import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudGastosFarmaciaByID = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetSolicitudGastosFarmaciaByID = () => {
  const [loadingGetSolicitudGastosFarmaciaByID, setLoadingGetSolicitudGastosFarmaciaByID] = useState(false);
  const [successGetSolicitudGastosFarmaciaByID, setSuccessGetSolicitudGastosFarmaciaByID] = useState(false);
  const [errorGetSolicitudGastosFarmaciaByID, setErrorGetSolicitudGastosFarmaciaByID] = useState<any>(null);
  const [dataGetSolicitudGastosFarmaciaByID, setDataSolicitudGastosFarmacia] = useState<any>(null);
  const [statusGetSolicitudGastosFarmaciaByID, setStatusGetSolicitudGastosFarmaciaByID] =
    useState<StatusGetSolicitudGastosFarmaciaByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getSolicitudGastosFarmaciaByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudGastosFarmaciaByID(true);
    setSuccessGetSolicitudGastosFarmaciaByID(false);
    setErrorGetSolicitudGastosFarmaciaByID(null);

    try {
      const res = await apiRecord.getSolicitudGastosContingenciaProfesionalFarmaciaByID(userId, prestacionId, id);

      setStatusGetSolicitudGastosFarmaciaByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudGastosFarmaciaByID(true);
      setDataSolicitudGastosFarmacia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetSolicitudGastosFarmaciaByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudGastosFarmaciaByID(err);
      console.error("Error en getSolicitudGastosFarmaciaByID:", err);

      throw err;
    } finally {
      setLoadingGetSolicitudGastosFarmaciaByID(false);
    }
  };

  return {
    getSolicitudGastosFarmaciaByID,
    loadingGetSolicitudGastosFarmaciaByID,
    successGetSolicitudGastosFarmaciaByID,
    errorGetSolicitudGastosFarmaciaByID,
    dataGetSolicitudGastosFarmaciaByID,
    statusGetSolicitudGastosFarmaciaByID
  };
};

export default useGetSolicitudGastosFarmaciaByID;
